import { computed, toValue } from "vue";
import { THEME_GREEN } from "@/data/constants";
import {
  clientRoutesNames,
  clientRouteBasePath,
} from "@/modules/client/routes";
import router from "@/router";

const brandsItem = computed(() => ({
  title: "Brands",
  icon: "$Brand",
  link: router.resolve({
    name: clientRoutesNames.brands.list(),
  }),
  routeName: clientRoutesNames.brands.list(),
  theme: THEME_GREEN,
  active: router.currentRoute.value.path.startsWith(
    `${clientRouteBasePath}/brands`,
  ),
}));

const categoriesItem = computed(() => ({
  title: "Categories",
  icon: "$Categories",
  link: router.resolve({
    name: clientRoutesNames.categories.list(),
  }),
  routeName: clientRoutesNames.root,
  theme: THEME_GREEN,
  active: router.currentRoute.value.path.startsWith(
    `${clientRouteBasePath}/categories`,
  ),
}));

const eRatailerItem = computed(() => ({
  title: "eRetailers",
  icon: "$Shop",
  link: router.resolve({
    name: clientRoutesNames.retailers.list(),
  }),
  routeName: clientRoutesNames.retailers.list(),
  theme: THEME_GREEN,
  active: router.currentRoute.value.path.startsWith(
    `${clientRouteBasePath}/retailers`,
  ),
}));

const marketsItem = computed(() => ({
  title: "Markets",
  icon: "$Location",
  link: router.resolve({
    name: clientRoutesNames.markets.list(),
  }),
  routeName: clientRoutesNames.markets.list(),
  theme: THEME_GREEN,
  active: router.currentRoute.value.path.startsWith(
    `${clientRouteBasePath}/markets`,
  ),
}));

export const drawerClientItems = () => {
  return [
    toValue(brandsItem),
    toValue(categoriesItem),
    toValue(eRatailerItem),
    toValue(marketsItem),
  ];
};
